/** Search opens an authorised canonical record independently of the workspace
 * selector. This is display context only; every API still checks actor access. */
const recordPath=/^\/(?:records\/(?:person|organisation|premises)|documents|communications\/threads|work\/(?:cases|actions)|compliance\/obligations)\/[a-f0-9-]{36}$/i;
export function searchWorkspace(pathname:string,search:string){
 const params=new URLSearchParams(search),workspace=params.get('workspaceBuilding'),back=params.get('returnTo');
 if(params.has('building')||params.has('developmentId'))return undefined;
 if(!recordPath.test(pathname)&&!(pathname==='/finance/payables'&&/^[a-f0-9-]{36}$/i.test(params.get('invoice')??'')))return undefined;
 if(!workspace||!/^[a-f0-9-]{36}$/i.test(workspace)||!back||!/^\/search(?:\?|$)/.test(back)||back.includes('\\'))return undefined;
 return workspace;
}
export function searchResultHref(path:string,returnTo:string,workspace?:string){
 const url=new URL(path,'https://staff.invalid');
 url.searchParams.set('returnTo',returnTo);
 if(workspace&&!url.pathname.startsWith('/buildings/'))url.searchParams.set('workspaceBuilding',workspace);
 return url.pathname+url.search;
}
